export const getVideoId = (videoUrl:string)=> {
    const youtube_regex = /^.*((m\.)?youtu\.be\/|vi?\/|u\/\w\/|embed\/|\?vi?=|\&vi?=)([^#\&\?]*).*/
    const parsed = videoUrl.match(youtube_regex);
    return parsed ? parsed[3] : '';
}